import styles from "./withdraw.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import moment from "moment";
import Loader from "../../components/loader";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import "./pagination.css";
export default function MatchingReward() {
  const navigate = useNavigate();
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [selectArray, setSelectArray] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    status: "",
    limit: 20,
  });
  const [loading, setLoading] = useState(false);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const getMatchinglisthandle = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.getMatchingRequest}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&status=PENDING&limit=${parameter.limit}`,
        { headers }
      );
      setLoading(false);
      setData(res?.data?.result[0].data);
      setTotalPages(res?.data?.result[0].metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  }, [currentPage, navigate, parameter, userToken]);

  useEffect(() => {
    getMatchinglisthandle();
  }, [getMatchinglisthandle]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const allSelections = data?.data.map((n) => ({
        userId: n.userId,
        rewardId: n._id,
      }));
      setSelectArray(allSelections);
    } else {
      setSelectArray([]);
    }
  };

  const handleWithdrwApprove = async (status) => {
    try {
      setLoading(true);
      setButtonLoading(true);

      const headers = {
        token: userToken,
      };

      const selectedData = selectArray.map((item) => ({
        status: status,
        userId: item.userId,
        rewardId: item.rewardId,
      }));

      const requests = selectedData.map((data) =>
        axios.post(`${apiConfig.claimMatchingRequest}`, data, { headers })
      );

      await Promise.all(requests);

      setSelectArray([]);
      getMatchinglisthandle();
      setLoading(false);
      setButtonLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setButtonLoading(false);
    }
  };

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Matching Rewards</h1>

      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search Email, NWithdraw Managementickname Or Referral ID"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getMatchinglisthandle();
                  }
                }}
              />
              <IoSearch
                className={styles.inputSearchIcon}
                onClick={getMatchinglisthandle}
              />
            </div>
          </div>
          <div className={styles.selectBox}>
            <span>Status</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    status: e.target.value,
                  });
                }}
                value={parameter?.planSubscription}
              >
                <option className={styles.optionMain} value={"ALL"}>
                  All
                </option>
                <option className={styles.optionMain} value={"COMPLETED"}>
                  Approved
                </option>
                <option className={styles.optionMain} value={"CANCELLED"}>
                  Rejected
                </option>
                <option
                  className={styles.optionMain}
                  value={"WAITING_APPROVAL"}
                >
                  Waiting Approval
                </option>
              </select>
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  fromDate: "",
                  toDate: "",
                  search: "",
                  status: "ALL",
                  limit: 20,
                });
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      {selectArray.length > 0 && (
        <>
          <div className={styles.userAddContainer}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleWithdrwApprove("APPROVED");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading ? "Loading..." : "Bulk Approve"}
            </button>

            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleWithdrwApprove("REJECTED");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading ? "Loading..." : "Bulk Reject"}
            </button>
          </div>
        </>
      )}
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width={"100px"} height={"100px"} />
        </div>
      ) : (
        <>
          {!data || data?.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th className={styles.flexTableData}>
                    <input
                      type="checkbox"
                      checked={
                        Array.isArray(data?.data) &&
                        data?.data.every((n) =>
                          selectArray.some(
                            (s) => s.userId === n.userId && s.rewardId === n._id
                          )
                        )
                      }
                      onClick={handleSelectAllClick}
                    />
                    No.
                  </th>
                  <th>Username</th>
                  <th>Full Name</th>
                  <th>Reward Name</th>
                  <th>Date & Time</th>
                  <th>Strong Team BV</th>
                  <th>Weak Team BV</th>
                  <th>Status</th>
                </tr>
                {data?.map((item, index) => {
                  return (
                    <tr>
                      <td className={styles.flexTableData}>
                        <input
                          type="checkbox"
                          className={styles?.checkInputTable}
                          checked={selectArray.some(
                            (n) =>
                              n.userId === item?.userId &&
                              n.rewardId === item?._id
                          )}
                          onClick={(e) => {
                            if (e.target.checked) {
                              // Add to selectArray with userId and rewardId
                              setSelectArray([
                                ...selectArray,
                                { userId: item?.userId, rewardId: item?._id },
                              ]);
                            } else {
                              // Remove from selectArray based on userId and rewardId
                              setSelectArray(
                                selectArray.filter(
                                  (n) =>
                                    !(
                                      n.userId === item?.userId &&
                                      n.rewardId === item?._id
                                    )
                                )
                              );
                            }
                          }}
                        />
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>

                      <td>{item?.nickName}</td>
                      <td>
                        {item?.firstName
                          ? item.firstName +
                            " " +
                            (item.lastName ? item.lastName : "NA")
                          : "NA"}
                      </td>
                      <td>{item.rewardName ? item.rewardName : "NA"}</td>
                      <td>
                        {moment(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                      <td>{item.strongTeamBV ? item.strongTeamBV : "0"}</td>
                      <td>{item.weakTeamBV ? item.weakTeamBV : "0"}</td>  
                      <td>{item?.status}</td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
